import api from "./axios";

export const getAiQuestions = async (params) => {
    const res = await api.post("/ai/questions", {params});
    return res.data;
};

export const createBulkQuestions = async (subjectId, questions, topic, language) => {
    const payload = {}
    payload.topic = topic;
    payload.questions = questions;
    payload.subjectId = subjectId;
    payload.language = language;
    const formData = new FormData();
    const jsonBlob = new Blob([JSON.stringify(payload)], {
        type: "application/json",
    });
    formData.append("payload", jsonBlob);

    const res = await api.post(`/questions/bulk`, formData);
    return res.data;
};

export const createBulkQuestionsByExamBase = async (examBaseId, questions, topic, language, subjectId) => {
    const payload = {}
    payload.topic = topic;
    payload.questions = questions;
    payload.language = language;
    if (subjectId != null && subjectId !== "") payload.subjectId = Number(subjectId);
    const formData = new FormData();
    const jsonBlob = new Blob([JSON.stringify(payload)], {
        type: "application/json",
    });
    formData.append("payload", jsonBlob);

    const res = await api.post(`/exam-bases/${examBaseId}/bulk-questions`, formData);
    return res.data;
};

// Generate an AI explanation for a single (possibly unsaved) question.
// payload: { text, options: [{ optionText, correct }], language }
export const generateQuestionExplanation = async (payload) => {
    const res = await api.post("/ai/question-explanation", payload);
    return res.data; // { explanation }
};
